<div>
    <!-- Header -->
    <div class="d-flex flex-column align-items-center pt-2 ">
        <mat-icon class="mt-0">warning_amber</mat-icon>
        <h1 class="text-center font-weight-bold">{{data.title}}</h1>
    </div>

    <mat-divider></mat-divider>

    <!-- Content -->
    <div mat-dialog-content class="pt-3">
        <p class="text-center">{{data.data}}</p>
    </div>

    <mat-divider></mat-divider>

    <!-- Actions -->
    <div mat-dialog-actions class="d-flex justify-content-around">
        <button mat-raised-button color="primary" mat-dialog-close>Okay</button>
    </div>
</div>